module.exports = __webpack_public_path__ + "static/media/18_after.97f4c546.jpg";